export const outputFields = [
    'type',
    'role',
    'content',
    'Google Search',
    'Twitter Search',
    'Google News Search',
    'Bing Search',
    'ArXiv Search',
    'Wikipedia Search',
    'Youtube Search',
    'search_metadata',
    'id',
    'status',
    'json_endpoint',
    'created_at',
    'processed_at',
    'google_url',
    'raw_html_file',
    'total_time_taken',
    'search_parameters',
    'engine',
    'q',
    'google_domain',
    'device',
    'search_information',
    'query_displayed',
    'total_results',
    'time_taken_displayed',
    'organic_results_state',
    'related_questions',
    'question',
    'title',
    'link',
    'list',
    'displayed_link',
    'next_page_token',
    'serpapi_link',
    'source_logo',
    'snippet',
    'date',
    'thumbnail',
    'organic_results',
    'position',
    'redirect_link',
    'favicon',
    'snippet_highlighted_words',
    'sitelinks',
    'inline',
    'source',
    'related_searches',
    'block_position',
    'query',
    'pagination',
    'current',
    'next',
    'other_pages',
    '2',
    '3',
    '4',
    '5',
    '6',
    '7',
    '8',
    '9',
    'Reddit Search',
    'url',
    'Hacker News Search',
    'Google Image Search',
    'google_images_url',
    'hl',
    'gl',
    'uds',
    'suggested_searches',
    'name',
    'images_results',
    'related_content_id',
    'serpapi_related_content_link',
    'original',
    'original_width',
    'original_height',
    'is_product',
    'tag',
    'highlighted_words',
    'serpapi_pagination',
    'completion',
    'summary',
    'search_summary',
    'texts',
    'is_intro_text',
    'data',
    'possibly_sensitive',
    'author_id',
    'edit_history_tweet_ids',
    'public_metrics',
    'includes',
    'api_params',
    'meta',
    'newest_id',
    'oldest_id',
    'result_count',
    'next_token',
    'url_suffix',
    'publish_time',
    'views',
    'duration',
    'long_desc',
    'channel',
    'title',
    'thumbnails',
    'query_displayed',
    'search_information',
    'tbm',
    'device',
    'google_domain',
    'time_taken_displayed',
    'total_results',
    'news_results_state',
]

export const multiSelectOptions = [
    { value: 'Google Search', label: 'Google Search', isSelected: true },
    { value: 'Google Image Search', label: 'Google Image Search', isSelected: false },
    { value: 'Hacker News Search', label: 'Hacker News Search', isSelected: false },
    { value: 'Reddit Search', label: 'Reddit Search', isSelected: false },
    { value: 'Google News Search', label: 'Google News Search', isSelected: false },
    { value: 'Wikipedia Search', label: 'Wikipedia Search', isSelected: false },
    { value: 'Youtube Search', label: 'Youtube Search', isSelected: false },
    { value: 'Twitter Search', label: 'Twitter Search', isSelected: false },
    // { value: 'Bing Search', label: 'Bing Search', isSelected: false },
    { value: 'ArXiv Search', label: 'ArXiv Search', isSelected: false },
    // { value: 'Discord Search', label: 'Discord Search', isSelected: false },
]

export const twitterTweetMultiSelectOptions = [
    { value: 'only_image', label: 'only_image', isSelected: false },
    { value: 'only_verified', label: 'only_verified', isSelected: true },
    { value: 'only_twitter_blue', label: 'only_twitter_blue', isSelected: true },
    { value: 'only_quote', label: 'only_quote', isSelected: false },
]

type OptionType = {
    value:
        | 'ScraperStreamingSynapse'
        | 'SearchSynapse'
        | 'TwitterTweetSynapse'
        | 'TwitterUserSynapse'
    label:
        | 'ScraperStreamingSynapse'
        | 'SearchSynapse'
        | 'TwitterTweetSynapse'
        | 'TwitterUserSynapse'
}

export const synapseOptions: OptionType[] = [
    { value: 'ScraperStreamingSynapse', label: 'ScraperStreamingSynapse' },
    { value: 'SearchSynapse', label: 'SearchSynapse' },
    // { value: 'TwitterTweetSynapse', label: 'TwitterTweetSynapse' },
    // { value: 'TwitterUserSynapse', label: 'TwitterUserSynapse' },
]

export const SearchDefaultState = {
    'Google Search': true,
    'Google Image Search': false,
    'Hacker News Search': false,
    'Reddit Search': false,
    'Wikipedia Search': false,
    'Youtube Search': false,
    'Twitter Search': false,
    // 'Bing Search': false,
    'ArXiv Search': false,
    // 'Discord Search': false,
}

export const googleDateFilterTypesOptions = [
    { value: null, label: 'default' },
    // last second / n working?
    { value: 'qdr:h', label: 'past hour' },
    { value: 'qdr:d', label: 'past 24 hours' },
    { value: 'qdr:w', label: 'past week' },
    { value: 'qdr:m', label: 'past month' },
    { value: 'qdr:y', label: 'past year' },
    { value: '', label: 'custom range...' },
]
export const dateFilterTypesOptions = [
    { value: 'PAST_24_HOURS', label: 'PAST_24_HOURS' },
    { value: 'PAST_2_DAYS', label: 'PAST_2_DAYS' },
    { value: 'PAST_WEEK', label: 'PAST_WEEK' },
    { value: 'PAST_2_WEEKS', label: 'PAST_2_WEEKS' },
    { value: 'PAST_MONTH', label: 'PAST_MONTH' },
    { value: 'PAST_2_MONTHS', label: 'PAST_2_MONTHS' },
    { value: 'PAST_YEAR', label: 'PAST_YEAR' },
    { value: 'PAST_2_YEARS', label: 'PAST_2_YEARS' },
]

export interface smartScrapeState {
    ScraperStreamingSynapse: {
        prompt: string
        language: string
        google_date_filter: string | null
        region: string
        start_date: string | null
        end_date: string | null
        tools: string[]
        date_filter_type: string | null
    }
    SearchSynapse: {
        query: string
        tools: string[]
    }
    TwitterUserSynapse: {
        request_type: string
        user_id: string
        username: string
        max_items: string
    }
    TwitterTweetSynapse: {
        prompt: string
        max_items: string
        min_retweets: string
        only_twitter_blue: boolean
        only_verified: boolean
        only_image: boolean
        only_quote: boolean
        language: string
        region: string
    }
}

export const smartScrapeInitialState: smartScrapeState = {
    ScraperStreamingSynapse: {
        prompt: 'what are news about in Georgia today?',
        start_date: null,
        end_date: null,
        google_date_filter: null,
        date_filter_type: null,
        language: 'en',
        region: 'us',
        tools: ['Google Search'],
    },
    SearchSynapse: {
        query: 'What are the recent sport events?',
        tools: ['Google Search'],
    },
    TwitterUserSynapse: {
        request_type: '',
        user_id: '',
        username: '',
        max_items: '',
    },
    TwitterTweetSynapse: {
        prompt: '',
        max_items: '3',
        min_retweets: '2',
        only_twitter_blue: true,
        only_verified: true,
        only_image: false,
        only_quote: false,
        language: 'en',
        region: 'en',
    },
}

export const searchModelOptions = [
    { value: 'NOVA', label: 'NOVA' },
    { value: 'ORBIT', label: 'ORBIT' },
    { value: 'HORIZON', label: 'HORIZON' },
]

export const responseOrderOptions = [
    { value: 'LINKS_FIRST', label: 'Links First' },
    { value: 'SUMMARY_FIRST', label: 'Summary First' },
]
